export default "__VITE_PUBLIC_ASSET__6c2836e6__"